import React from 'react'
import './formationCards.css'
import ProgressBar from 'react-bootstrap/ProgressBar';
import { dateFormat } from '../../../helper/dataFormat';
import logger from '../../../utils/logger';
import { formationDateFormat } from '../../../helper/formationDateFormat';

import { OverlayTrigger } from "react-bootstrap";
import { Tooltip } from "react-bootstrap";
import { TagOverflow } from '../TagOverflow/TagOverflow';
import { retry } from '@reduxjs/toolkit/query';
import { Link } from 'react-router-dom';
import { div } from 'framer-motion/client';

export const FormationCards = ({
  name,
  formationPlace,
  maxQuota,
  professors,
  members,
  description,
  date,
  id

}) => {

  logger.debug('professors: ', professors)

  const isFormationActive = (date) => {
    const currentDate = new Date()
    const startDate = new Date(date)

    return startDate.setHours(0, 0, 0, 0) >= currentDate.setHours(0, 0, 0, 0)

  };


  const quotaPercentage = (members, maxCuota) => {
    const total = (members * 100) / maxCuota

    return total
  }

  const progressBarColor = (members, maxCuota) => {

    const percentage = quotaPercentage(members, maxCuota)

    if (percentage === 0) return "progress-bar-empty"
    if (percentage <= 75) return "progress-bar-active"
    if (percentage <= 99) return "almost-full"
    if (percentage >= 100) return "progress-bar-full"

  }

  const quotaLabel = (members, maxCuota) => {

    const percent = quotaPercentage(members, maxCuota)

    return percent === 100 ? "Completo" : "Lugares"
  }

  const professorsFakeArray = [

    { id: 0, name: 'Qwerty Teclado' },
    { id: 1, name: 'Pretta Negra' },
    { id: 2, name: 'Canela Bizcochita' },
    { id: 3, name: 'Froda Panzona' },
    { id: 4, name: 'Colin ' },
    { id: 5, name: 'Blacki' },
  ]
  // 
  const visibleTags = professorsFakeArray.slice(0, 2);

  logger.debug('visibleTags slice: ', visibleTags)
  const extraCount = professorsFakeArray.length - 2;



  return (
    <Link to={`/FormationsDetail/${id}`} className='formation-cards'>

      <OverlayTrigger
        placement="bottom"
        overlay={<Tooltip id={`tooltip-${name}`}>{name}</Tooltip>}>

        <h3>{name}</h3>

      </OverlayTrigger>

      {professors.length === 0 ?

        <div className='tag-container'>

          <span className='tag-chip'>No hay profesores asignados</span>
        </div>


        :
        <TagOverflow tags={professors} />

      }




      <div className='formation-card-item-3 d-flex flex-column'>

        <div className="formation-calendar-container d-flex gap-2">

          <span className="material-symbols-outlined formation-text-color" aria-hidden="true" role="none">
            date_range
          </span>

          <p className='formation-text-color'>{formationDateFormat(date)}</p>


        </div>

        <div className="formation-place-container d-flex gap-2">

          <span className="material-symbols-outlined formation-text-color" aria-hidden="true" role="none">
            location_on
          </span>
          <p className='formation-text-color'> {formationPlace?.name}</p>

        </div>

      </div>


      <div className="progress-bar-container d-flex align-items-center gap-2">

        <ProgressBar
          now={members?.length}
          max={maxQuota}
          className={`progress-bar-width ${progressBarColor(members.length, maxQuota)}`}
        />

        <p
          className=' formation-text-color quota-label m-0 '
        >
          {`${members.length}/${maxQuota} ${quotaLabel(members.length, maxQuota)}`}
        </p>

        {/* <p>{progressBarColor(members.length,maxQuota)}</p> */}
      </div>


      <div className='formation-status-info '>
        <span className={`status-circle ${isFormationActive(date) ? 'bg-training-active' : 'bg-training-completed'}`}></span>

        <span className={`formation-status-span ${isFormationActive(date) ? 'training-active' : 'training-completed'}`}>

          {isFormationActive(date) ? 'Activa' : 'Finalizada'}

        </span>
      </div>

    </Link>
  )
}
